export default __webpack_public_path__ + "static/media/Enquiry.a03b1279.svg";